import React, { useEffect, useState } from 'react';
import styles from './HowItWorks.module.scss';

const ScrollIndicator = ({ count, target }) => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const selectedDotValue = (scrollProgress * count) / 100;

  const scrollListener = () => {
    if (!target.current) {
      return;
    }

    const element = target.current;
    const windowScroll = element.scrollLeft;
    const totalWidth = element.scrollWidth - element.clientWidth;
    if (windowScroll === 0) {
      return setScrollProgress(0);
    }

    if (windowScroll > totalWidth) {
      return setScrollProgress(100);
    }

    setScrollProgress((windowScroll / totalWidth) * 100);
  };

  useEffect(() => {
    target.current.addEventListener('scroll', scrollListener);
    return () => target.current && target.current.removeEventListener('scroll', scrollListener);
  });
  return (
    <section className={styles.dotContainer}>
      {[...Array(count)].map((val, index) => (
        <span
          className={`${styles.dots} ${selectedDotValue >= index ? styles.active : ''}`}
          key={index}
        ></span>
      ))}
    </section>
  );
};

export default ScrollIndicator;
